import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
// import SearchBar from "@saleor/components/SearchBar";
import { InstagramList_instagrams_edges_node } from "@saleor/instagram/types/InstagramList";
import { InstagramListUrlSortField } from "@saleor/instagram/urls";
import { sectionNames } from "@saleor/intl";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SearchPageProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import InstagramList from "../InstagramList";
import {
  createFilterStructure,
  InstagramFilterKeys,
  InstagramListFilterOpts
} from "./filters";

export interface InstagramListPageProps
  extends PageListProps,
    SearchPageProps,
    ListActions,
    SortPage<InstagramListUrlSortField>,
    FilterPageProps<InstagramFilterKeys, InstagramListFilterOpts>,
    TabPageProps {
  instagram: InstagramList_instagrams_edges_node[];
  toatlCount: number;
}

const InstagramListPage: React.FC<InstagramListPageProps> = ({
  initialSearch,
  onAdd,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  toatlCount,
  filterOpts,
  currencySymbol,
  onFilterChange,
  ...listProps
}) => {
  const intl = useIntl();
  const filterStructure = createFilterStructure(intl, filterOpts);

  return (
    <Container>
      <PageHeader
        title={
          intl.formatMessage(sectionNames.instagramList) +
          "(" +
          toatlCount +
          ")"
        }
      ></PageHeader>
      <Card>
        <FilterBar
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          initialSearch={initialSearch}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
          tabs={tabs}
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Content",
            description: "tab name"
          })}
          filterStructure={filterStructure}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Content..."
          })}
        />
        <InstagramList {...listProps} />
      </Card>
    </Container>
  );
};

export default InstagramListPage;
